import { Avatar, AvatarProps } from '@material-ui/core';
import { forwardRef } from 'react';
import { ColoredCommonProps, withColoredStyles } from './common';

type ColoredAvatar = {
  <C extends React.ElementType>(
    props: AvatarProps<C, { component?: C }> & ColoredCommonProps
  ): JSX.Element;
};

export const ColoredAvatar = withColoredStyles(
  forwardRef(({ colored, coloredHover, ...props }: any, ref) => <Avatar ref={ref} {...props} />)
) as ColoredAvatar;
